import { render, staticRenderFns } from "./DrinkingWaterWriteBody.vue?vue&type=template&id=22e85239&scoped=true"
import script from "./DrinkingWaterWriteBody.vue?vue&type=script&lang=js"
export * from "./DrinkingWaterWriteBody.vue?vue&type=script&lang=js"
import style0 from "./DrinkingWaterWriteBody.vue?vue&type=style&index=0&id=22e85239&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e85239",
  null
  
)

export default component.exports